define([],
	function() {
		var ParseMode = {
			TAG_NAME: 0,
			CHILD_INDEX: 1,
			AFTER_CHILD_INDEX: 2,
			ELEMENT_ID: 3,
			CLASS_LIST: 4
		};
		var PathPartParser = function(){
			this.onUnexpectedSymbol = function(){
				throw new Error("Not expected " + this.char + " at " + this.index + " position in " + this.pathPartString);
			};
			this.parseTagName = function(){
				switch(this.char){
					case "[":
						//Do not allow expression to start with index without tagName
						if(this.tagName == ""){
							throw new Error("Tagname should be preceding child index in " + this.pathPartString);
						}
						this.mode = ParseMode.CHILD_INDEX;
					break;
					case "#":
						this.mode = ParseMode.ELEMENT_ID;
					break;
					case ".": 
						this.mode = ParseMode.CLASS_LIST;
					break;
					case "]":
						this.onUnexpectedSymbol();
					break;
					case "/":
						
					break;
					default:
						this.tagName += this.char;
					break;	
				}				
			},
			this.parseChildIndex = function(){
				switch(this.char){
					case "]": 
						if(this.childIndexString == ""){
							throw new Error("Child index should not be empty in " + this.pathPartString);
						}
						//No support for multiple wildcards in the child index expression
						if(this.childIndexString == "*"){
							this.childIndex = 0;
						}
						else{
							this.childIndex = Number(this.childIndexString);
							if(isNaN(this.childIndex) || this.childIndex % 1 !== 0){
								throw new Error("Child index should be integer or * in " + this.pathPartString);
							}
						}
						this.mode = ParseMode.AFTER_CHILD_INDEX;
					break;
					case "/":
						throw new Error("No closing ] found in " + this.pathPartString);
					case ".":
					case "#":
					case "[":
						this.onUnexpectedSymbol();
					break;
					default:
						this.childIndexString += this.char;
					break;	
				}			
			},
			this.parseAfterChildIndex = function(){
				switch(this.char){
					case ".":
						this.mode = ParseMode.CLASS_LIST;
					break;
					case "*":
						this.classString = "*";
						this.mode = ParseMode.CLASS_LIST;
					break;
					case "#":
						this.mode = ParseMode.ELEMENT_ID;
					break;
					case "/":
					break;
					default:
						this.onUnexpectedSymbol();
					break;
				}	
			},
			this.parseElementId = function(){
				switch(this.char){
					case "/":
					case ".": 
						//If # is present element id can not be empty
						if(this.elementId == ""){
							throw new Error("Element id should not be empty in " + this.pathPartString);
						}
						this.mode = ParseMode.CLASS_LIST;
					break;
					case "#":
					case "[":
					case "]":
						this.onUnexpectedSymbol();
					break;
					default:
						this.elementId += this.char;
					break;	
				}			
			},
			this.parseClassList = function(){
				switch(this.char){
					case "/":
					case ".": 
						if(this.classString != ""){
                            this.classList.push(this.classString);
							this.classString = "";
						}
					break;
					case "[":
					case "]":
					case "#":
						this.onUnexpectedSymbol();
					break;
					default:
						this.classString += this.char;
					break;	
				}	
			},
			this.parse = function(pathPartString){
				this.char = "";
				this.mode = ParseMode.TAG_NAME;
				this.tagName = "";
				this.elementId = "";
				this.classList = [];
				this.classString = "";
				this.childIndex = -1;
				this.childIndexString = "";
				this.pathPartString = "\"" + pathPartString + "\"";
				var pathPartWithTerminal = pathPartString + "/",
					charCount = pathPartWithTerminal.length;
				for(var i = 0; i < charCount;i++){
					this.char = pathPartWithTerminal.charAt(i);
					//Skip whitespace
					if(this.char == " ")
						continue;
					this.index = i;
					switch(this.mode){
						case ParseMode.TAG_NAME:
							this.parseTagName();
						break;
						case ParseMode.CHILD_INDEX:
							this.parseChildIndex();
						break;
						case ParseMode.AFTER_CHILD_INDEX:
							this.parseAfterChildIndex();
						break;
						case ParseMode.ELEMENT_ID:
							this.parseElementId();
						break;
						case ParseMode.CLASS_LIST:
							this.parseClassList();
						break;	
					};
				};
				return {
					pathPartString: pathPartString,
					tagName: this.tagName,
					elementId: this.elementId,
					classList: this.classList,
					childIndex: this.childIndex
				};
			};			
		};
		var ElementsPathParser = function(){
			this.parse = function(pathString){
				//Order always like this tag#id.class
				//Only one "#" symbol per path part
				var parts = pathString.split("/"),
					path = [],
					partParser = new PathPartParser();
				for(var i = 0; i < parts.length;i++){
					var pathPart = parts[i];
					//empty path parts are ignored
					if(pathPart.length != 0){
						path.push(partParser.parse(pathPart));
					}
				}
				return path;
			};
		};
		return ElementsPathParser;
	}
);






//////////////////
// WEBPACK FOOTER
// ./utils/ElementsPathParser.js
// module id = 6
// module chunks = 0